import { routes } from 'Routes/routesConfig';
import { GA4RouteType, pathTypes } from './types';

const vehicleDetails = 'vehicle details';
const bookAppointment = 'book appointment';

export type GARoutesAdapter = { [key: string]: GA4RouteType };

export const gaMotorRoutes: GARoutesAdapter = {
  [routes.CASE_OPENING]: {
    page_name: 'landing page',
    funnel_step: '1',
    step_name: 'landing page',
  },
  [routes.VEHICLE_DETAILS]: {
    funnel_step: '2',
    step_name: vehicleDetails,
  },
  [routes.LOCATION_DETAILS_MAP]: {
    page_name: 'location map',
    funnel_step: '3',
    step_name: 'location',
    path_type: pathTypes.HAPPY,
  },
  [routes.INCIDENT_DESCRIPTION]: {
    page_name: 'diagnostic tree - step 1',
    funnel_step: '4.1',
    step_name: 'incident',
    path_type: pathTypes.HAPPY,
  },
  [routes.SYNERGY_ADDITIONAL_QUESTIONS]: {
    page_name: 'additional questions',
    funnel_step: '4.3',
    step_name: 'additional questions',
    path_type: pathTypes.HAPPY,
  },
  [routes.SYNERGY_INCIDENT_UNDERSTOOD]: {
    page_name: 'reinsurance screen',
    funnel_step: '4.4',
    step_name: 'reinsurance',
    path_type: pathTypes.HAPPY,
  },
  [routes.PASSENGERS]: {
    page_name: 'passenger details',
    funnel_step: '5',
    step_name: 'passengers',
    path_type: pathTypes.HAPPY,
  },
  [routes.SYNERGY_CONTACT_DETAILS]: {
    page_name: 'contact details',
    funnel_step: '6',
    step_name: 'contact',
    path_type: pathTypes.HAPPY,
  },
  [routes.SUMMARY]: {
    page_name: 'summary',
    funnel_step: '6.1',
    step_name: 'case summary',
    path_type: pathTypes.HAPPY,
    request_type: 'request assistance now',
  },
  [routes.SYNERGY_BOOK_APPOINTMENT]: {
    page_name: 'date and time appointment',
    funnel_step: '6.2',
    step_name: bookAppointment,
    path_type: pathTypes.HAPPY,
    request_type: bookAppointment,
    assistance_type: bookAppointment,
  },
  [routes.SYNERGY_CASE_STATUS]: {
    page_name: 'status confirmation',
    funnel_step: '7',
    step_name: 'confirmation',
    path_type: pathTypes.HAPPY,
  },
  [routes.CONFIRMATION]: {
    page_name: 'status confirmation',
    funnel_step: '7',
    step_name: 'confirmation',
    path_type: pathTypes.HAPPY,
  },
  [routes.CALLBACK]: {
    page_name: 'call back',
    funnel_step: '7.1',
    step_name: 'call back',
    path_type: pathTypes.UNHAPPY,
  },
  [routes.SYNERGY_DESTINATION]: {
    page_name: 'choose the garage',
    funnel_step: '8',
    step_name: 'destination',
    path_type: pathTypes.HAPPY,
  },
  [routes.SYNERGY_DESTINATION_MAP]: {
    page_name: 'destination map',
    funnel_step: '8',
    step_name: 'destination',
    path_type: pathTypes.HAPPY,
  },
  [routes.GARAGE_ORIENTATION]: {
    page_name: 'garage orientation',
    funnel_step: '8',
    step_name: 'destination',
    path_type: pathTypes.HAPPY,
  },
  [routes.FOLLOW_MY_CASE_STATUS]: {
    page_name: 'follow up',
    funnel_step: '9',
    step_name: 'follow up',
    path_type: pathTypes.HAPPY,
  },
  [routes.CONTACT_US]: {
    page_name: 'drop off',
    path_type: pathTypes.UNHAPPY,
  },
  [routes.CONTACT_US_ACCIDENT]: {
    page_name: 'drop off accident',
    drop_off_type: 'accident',
    path_type: pathTypes.UNHAPPY,
  },
  [routes.CONTACT_US_CASE_CREATION_FAIL]: {
    page_name: 'drop off case creation fail',
    drop_off_type: 'case_creation_fail',
    path_type: pathTypes.UNHAPPY,
  },
  [routes.CONTACT_US_DUPLICATE]: {
    page_name: 'drop off duplicate',
    drop_off_type: 'duplicate',
    path_type: pathTypes.UNHAPPY,
  },
  [routes.CONTACT_US_MOTORWAY]: {
    page_name: 'drop off motorway',
    drop_off_type: 'motorway',
    path_type: pathTypes.UNHAPPY,
  },
  [routes.FOLLOW_MY_CASE_ENTRY]: {
    page_name: 'follow my case',
    path_type: pathTypes.HAPPY,
  },
};
